import { render, staticRenderFns } from "./CadProfissionais.vue?vue&type=template&id=56a24139"
import script from "./CadProfissionais.vue?vue&type=script&lang=js"
export * from "./CadProfissionais.vue?vue&type=script&lang=js"
import style0 from "./CadProfissionais.vue?vue&type=style&index=0&id=56a24139&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports